import type { ReactNode } from 'react';
import { LogoMark } from '@/components/Brand';
import { Prefs } from '@/components/Prefs';
import { BackHome } from '@/components/BackHome';
import { openAssistant } from '@/help/assistant-store';
import { MessageCircleQuestion } from 'lucide-react';
import { PoweredBy } from '@/components/PoweredBy';
import { useT } from '@/i18n/context';

/** غلاف الشاشات العامة — المكان الوحيد الذي يُسمح فيه بالتدرج الرسمي داخل المنتج */
export function AuthLayout({ title, children, aside }: { title: string; children: ReactNode; aside?: ReactNode }) {
  const t = useT();
  return (
    <div className="auth">
      <aside className="auth__aside">
        {/*
          الشعارُ كبيرٌ والكلامُ كلامُ الصفحة الأولى نفسُه (طلب صاحب المنصة 20 سبتمبر
          2026): من جاء من الصفحة الأولى إلى الدخول يجد الوجهَ نفسَه لا وجهاً ثانياً.
        */}
        <div className="stack gap-6 auth__brand">
          <div className="auth__mark" role="img" aria-label="رفرفة"><LogoMark size={170} /></div>
          <div className="stack gap-3">
            <p className="auth__headline">{t('auth.headline')}</p>
            <p className="auth__tagline">{t('auth.tagline')}</p>
            <p className="auth__lede">{aside ?? t('auth.lede')}</p>
          </div>
        </div>
        <p className="caption auth__foot">{t('auth.foot')}</p>
      </aside>

      <main className="auth__panel">
        <div className="auth__form">
          {/* لا ترويسةَ هنا يعود منها الزائر — فالزرُّ مكتوبٌ بكلماته (19 سبتمبر 2026) */}
          {/* سطرٌ واحد: العودة · اسأل المساعد · اللغة (25 أكتوبر 2026 — صفحةُ الدخول بلا تمرير) */}
          <div className="auth__top">
            <BackHome />
            {/* «اسأل المساعد» قبل الدخول (29 سبتمبر 2026): أيُّ بابٍ لي؟ لم يصلني الرمز؟ */}
            <button type="button" className="link-btn auth__ask" data-testid="auth-ask" onClick={() => openAssistant()}><MessageCircleQuestion size={16} aria-hidden /> اسأل المساعد</button>
            <div className="auth__prefs"><Prefs /></div>
          </div>
          <h1 className="auth__title">{title}</h1>
          {children}
          <PoweredBy className="auth__powered" />
        </div>
      </main>
    </div>
  );
}
